import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import Sidebar from '../mendepartmentdetails/Sidebar';
import SubDeptImage from '../../../assets/image/department/rear-view-stressed-shocked-businessman-realized-problem-office_1163-5112.jpg';

function JobTrainingSkills() {
  const [Faq, setFaq] = useState(0); // first dropdown open by default
  const titleRef = useRef(null);
  const [titleColor, setTitleColor] = useState('');

  useEffect(() => {
    if (titleRef.current) {
      const c = window.getComputedStyle(titleRef.current).color;
      setTitleColor(c);
    }
  }, []);

  // shared inline styles (match other extended pages)
  const liRow = { display: 'flex', alignItems: 'flex-start', gap: '10px', marginBottom: '12px' };
  const icon = { marginTop: '4px', flex: '0 0 auto' };
  const kv = { display: 'flex', flexDirection: 'column', gap: '4px', flex: 1, minWidth: 0 };
  const keyText = { fontWeight: 700, fontSize: '1.1rem', lineHeight: 1.35, color: '#0f172a' };
  const valText = { fontSize: '1rem', lineHeight: 1.6, color: '#334155' };
  const overviewText = { color: titleColor || '#0f172a', fontSize: '1.05rem', lineHeight: 1.6, margin: '8px 0 16px' };

  const sections = [
    {
      Que: 'Program Pathways',
      Answer: (
        <ul className="list-unstyled list-style">
          {[
            ['Short-term bootcamps:', '4–12 week intensive skills programs aligned to specific job roles.'],
            ['Certificate tracks:', 'Industry-aligned courses that stack toward diplomas or degrees.'],
            ['Apprenticeships:', 'Earn-and-learn models combining paid work with related instruction.'],
          ].map(([k, v], i) => (
            <li key={`path-${i}`} style={liRow}>
              <i className="fa-solid fa-circle-arrow-right" style={icon} />
              <div style={kv}><span style={keyText}>{k}</span><span style={valText}>{v}</span></div>
            </li>
          ))}
        </ul>
      ),
    },
    {
      Que: 'In-Demand Sectors',
      Answer: (
        <ul className="list-unstyled list-style">
          {[
            ['IT & Digital:', 'Help desk, desktop support, web dev basics, cloud fundamentals.'],
            ['Skilled Trades:', 'Electrical, HVAC, carpentry, welding fundamentals with safety.'],
            ['Healthcare:', 'CNA/MA prep, phlebotomy, patient care tech, medical office admin.'],
            ['Logistics & Manufacturing:', 'Forklift certs, quality basics, lean, CNC/production ops.'],
          ].map(([k, v], i) => (
            <li key={`sectors-${i}`} style={liRow}>
              <i className="fa-solid fa-circle-arrow-right" style={icon} />
              <div style={kv}><span style={keyText}>{k}</span><span style={valText}>{v}</span></div>
            </li>
          ))}
        </ul>
      ),
    },
    {
      Que: 'Credentials & Funding',
      Answer: (
        <ul className="list-unstyled list-style">
          {[
            ['Industry certs:', 'CompTIA, OSHA-10/30, CPR/BLS, forklift, ServSafe, and more based on track.'],
            ['Tuition help:', 'Scholarships, WIOA eligibility, employer sponsorships, and fee waivers where available.'],
            ['Exam prep & vouchers:', 'Study guides, practice tests, and proctoring coordination.'],
          ].map(([k, v], i) => (
            <li key={`cred-${i}`} style={liRow}>
              <i className="fa-solid fa-circle-arrow-right" style={icon} />
              <div style={kv}><span style={keyText}>{k}</span><span style={valText}>{v}</span></div>
            </li>
          ))}
        </ul>
      ),
    },
    {
      Que: 'Work-Based Learning',
      Answer: (
        <ul className="list-unstyled list-style">
          {[
            ['Internships & co-ops:', 'Paid placements that apply classroom skills on the job.'],
            ['Job shadows:', 'Short exposures to real worksites for career fit checks.'],
            ['Capstone projects:', 'Portfolio-ready work simulating client deliverables.'],
          ].map(([k, v], i) => (
            <li key={`wbl-${i}`} style={liRow}>
              <i className="fa-solid fa-circle-arrow-right" style={icon} />
              <div style={kv}><span style={keyText}>{k}</span><span style={valText}>{v}</span></div>
            </li>
          ))}
        </ul>
      ),
    },
    {
      Que: 'Career Services',
      Answer: (
        <ul className="list-unstyled list-style">
          {[
            ['Resume & interview:', 'Targeted resumes, mock interviews, and LinkedIn optimization.'],
            ['Job matching:', 'Referrals to vetted employers and hiring events.'],
            ['Soft skills:', 'Communication, teamwork, time management, and workplace etiquette.'],
          ].map(([k, v], i) => (
            <li key={`career-${i}`} style={liRow}>
              <i className="fa-solid fa-circle-arrow-right" style={icon} />
              <div style={kv}><span style={keyText}>{k}</span><span style={valText}>{v}</span></div>
            </li>
          ))}
        </ul>
      ),
    },
    {
      Que: 'Accessibility & Support Services',
      Answer: (
        <ul className="list-unstyled list-style">
          {[
            ['Tutoring & labs:', 'Open labs, tutoring sessions, and test-taking accommodations.'],
            ['Barriers to work:', 'Transportation support, childcare referrals, equipment/boot stipends when available.'],
            ['Language & disability access:', 'Interpreter services and ADA accommodations on request.'],
          ].map(([k, v], i) => (
            <li key={`support-${i}`} style={liRow}>
              <i className="fa-solid fa-circle-arrow-right" style={icon} />
              <div style={kv}><span style={keyText}>{k}</span><span style={valText}>{v}</span></div>
            </li>
          ))}
        </ul>
      ),
    },
    {
      Que: 'Employer Partnerships',
      Answer: (
        <ul className="list-unstyled list-style">
          {[
            ['Advisory input:', 'Curriculum shaped by employer councils to match hiring needs.'],
            ['Talent pipelines:', 'Interview days, onsite tours, and preferred-candidate pathways.'],
            ['Upskilling incumbent workers:', 'Customized cohorts delivered with employers for advancement.'],
          ].map(([k, v], i) => (
            <li key={`employ-${i}`} style={liRow}>
              <i className="fa-solid fa-circle-arrow-right" style={icon} />
              <div style={kv}><span style={keyText}>{k}</span><span style={valText}>{v}</span></div>
            </li>
          ))}
        </ul>
      ),
    },
    {
      Que: 'Tracking Outcomes & Next Steps',
      Answer: (
        <ul className="list-unstyled list-style">
          {[
            ['Completion & placement:', 'Measured program completions, certifications earned, and job placement rates.'],
            ['Alumni follow-up:', '6–12 month check-ins for advancement, wage growth, and additional training needs.'],
            ['Continuous improvement:', 'Update modules based on feedback, labor data, and employer demand.'],
          ].map(([k, v], i) => (
            <li key={`outcomes-${i}`} style={liRow}>
              <i className="fa-solid fa-circle-arrow-right" style={icon} />
              <div style={kv}><span style={keyText}>{k}</span><span style={valText}>{v}</span></div>
            </li>
          ))}
        </ul>
      ),
    },
  ];

  return (
    <section className="department-details-section">
      <div className="container">
        <div className="row">

          {/* Sidebar */}
          <div className="col-12 col-lg-4 col-xl-4">
            <Sidebar />
          </div>

          {/* Main Content */}
          <div className="col-lg-8">
            <div className="department-details-imgbox">
              <img src={SubDeptImage} className="img-fluid" alt="Job Training and Skills Development" />
            </div>

            <div className="department-details-content-box">
              <h4 ref={titleRef} className="department-details-title">Job Training and Skills Development</h4>

              {/* Overview (always visible, same color as title but smaller) */}
              <p style={overviewText}>
                Hands-on training, stackable credentials, and direct employer connections—so you gain practical skills,
                earn industry-recognized certifications, and land work in high-demand fields.
              </p>
            </div>

            {/* Accordion (expanded information) */}
            <div className="accordian-box">
              {sections.map((item, index) => (
                <div className={`accordian-box-item ${Faq !== index && 'active'}`} key={index}>
                  <div className="accordian-title">
                    <h5>{item.Que}</h5>
                    <i
                      className="fa-solid fa-angle-right"
                      onClick={() => setFaq(index)}
                      role="button"
                      aria-label={`Toggle ${item.Que}`}
                    />
                  </div>

                  {Faq === index && (
                    <div className="accordian-content" style={{ display: 'block' }}>
                      {item.Answer}
                    </div>
                  )}
                </div>
              ))}
            </div>

            <div className="department-details-policy-box">
              <h4>Our Commitment:</h4>
              <p>
                We align training with real jobs, remove barriers to completion, and support long-term career growth—
                from the first certification to your next promotion.
              </p>
            </div>

            <div>
              <Link to="/department/employment">
                <i className="fa-solid fa-circle-arrow-left" style={{ marginRight: '5px' }} />
                Go Back
              </Link>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}

export default JobTrainingSkills;
